import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  if (currentPath === '/tutti-helper' || currentPath.startsWith('/tutti-helper/')) return null;
  if (['/jikeyixia', '/jikeyixia/', '/tailscale-doctor', '/tailscale-doctor/'].includes(currentPath)) return null;

  const navItems = [
    { path: '/', label: 'Dashboard' },
    { path: '/timeline', label: 'Timeline' },
    { path: '/lab', label: 'Lab' },
  ];

  return (
    <>
      <nav className="floating-tab">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`floating-tab-item ${currentPath === item.path ? 'active' : ''}`}
          >
            {item.label}
          </Link>
        ))}
      </nav>
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-links">
            <Link to="/privacy" className="footer-link">Privacy Policy</Link>
            <span className="footer-separator">•</span>
            <span className="footer-copyright">© 2025 PeaceTech. All rights reserved.</span>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
